import { render, staticRenderFns } from "./ImportantRule.vue?vue&type=template&id=614fd018&scoped=true"
import script from "./ImportantRule.vue?vue&type=script&lang=js"
export * from "./ImportantRule.vue?vue&type=script&lang=js"
import style0 from "./ImportantRule.vue?vue&type=style&index=0&id=614fd018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614fd018",
  null
  
)

export default component.exports